import styles from './sideTiles.module.css';
import { Icons } from '../../../code/IconHandler';
import { useNavigate, useLocation } from 'react-router-dom';
import { kursabmeldung, anmeldungCamp, mitgliedantragTuS } from '../../../config/references_files';
function SideTiles() {
    const navigate = useNavigate();
    const location = useLocation();
    const HIDDEN_SIDETILES = ["/admin", kursabmeldung, anmeldungCamp, "/service/flexkarte-bestellen", mitgliedantragTuS];
    const isSideTileHidden = HIDDEN_SIDETILES.some(path =>
        location.pathname.startsWith(path)
    );
    if (isSideTileHidden) {
        return (<></>);
    }
    return (
        <div className={styles.container}>
            {/* TEXT tile (vertical) */}
            <div className={styles.tile}>
                <div className={styles.icon}
                // style={{ backgroundColor: getBackgroundColor(location) }}
                >
                    <p>Werde Mitglied</p>
                    <Icons.MemberCard />
                </div>
                <div className={styles.expandedContent}
                // style={{ backgroundColor: get80BackgroundColor(location) }}
                >
                    <div className={`${styles.section} ${styles.member}`}>
                        <div>
                            <p className={styles.head}>Werde Mitglied beim TuS 05</p>
                            {/* <p className={styles.sub}>Mehr Infos über die Links</p> */}
                        </div>
                        <div className={styles.buttons}>
                            <span

                                onClick={() => navigate('/werde-teil-von-uns')}
                                style={{ cursor: 'pointer' }}
                            >
                                Mehr Details
                            </span>
                            <span

                                onClick={() => navigate('/service/mitgliedsantrag-tus')}
                                style={{ cursor: 'pointer' }}
                            >
                                Zum Anmeldeformular
                            </span>

                        </div>
                    </div>
                </div>
            </div >
            {/* <div className={styles.tile}>
                <div className={styles.icon}
                >

                    <Icons.Info />
                </div>
                <div className={styles.expandedContent}
                // style={{ backgroundColor: get80BackgroundColor(location) }}
                >
                    <div className={`${styles.section}`}>
                        <a className={`${styles.head} ${styles.underline}`} href='/unser-verein/tus-05-organisation#geschaeftsstelle'>Kontakinformationen</a>
                    </div>
                </div>
            </div> */}
            {/* ICON tile (horizontal) */}
            <div className={styles.tile}>
                <div className={styles.icon}
                // style={{ backgroundColor: getBackgroundColor(location) }}
                >
                    {/* <Icons.Pregnant /> */}

                    <Icons.Health />
                </div>
                <div className={styles.expandedContent}
                // style={{ backgroundColor: get80BackgroundColor(location) }}
                >
                    <div className={`${styles.section}`}>
                        <span
                            className={`${styles.head} ${styles.underline}`}
                            onClick={() => navigate('/mama-plus-programm')}
                            style={{ cursor: 'pointer' }}
                        >
                            Unser MamaPlus Programm
                        </span>

                    </div>
                </div>
            </div>
            <div className={styles.tile}>
                <div className={styles.icon}
                >

                    <Icons.News />
                </div>
                <div className={styles.expandedContent}
                // style={{ backgroundColor: get80BackgroundColor(location) }}
                >
                    <div className={`${styles.section}`}>
                        <span
                            className={`${styles.head} ${styles.underline}`}
                            onClick={() => navigate('/news')}
                            style={{ cursor: 'pointer' }}
                        >
                            Unsere News
                        </span>

                    </div>
                </div>
            </div>
            <div className={styles.tile}>
                <div className={styles.icon}
                >

                    <Icons.Calender />
                </div>
                <div className={styles.expandedContent}
                // style={{ backgroundColor: get80BackgroundColor(location) }}
                >
                    <div className={`${styles.section}`}>
                        <span
                            className={`${styles.head} ${styles.underline}`}
                            onClick={() => navigate('/service/terminkalender')}
                            style={{ cursor: 'pointer' }}
                        >
                            Unser Terminkalender
                        </span>

                    </div>
                </div>
            </div>
            <div className={styles.tile}>
                <div className={styles.icon}
                >

                    <Icons.SportOffer />
                </div>
                <div className={styles.expandedContent}
                // style={{ backgroundColor: get80BackgroundColor(location) }}
                >
                    <div className={`${styles.section}`}>
                        <span
                            className={`${styles.head} ${styles.underline}`}
                            onClick={() => navigate('/service/sportangebot')}
                            style={{ cursor: 'pointer' }}
                        >
                            Unser Sportangebot
                        </span>
                    </div>
                </div>
            </div>

        </div >
    );
}

export default SideTiles;
